import { useState } from "react";
import { useTheme } from "@mui/material";
import useHeartLongPressStats from "../../../components/hooks/useHeartLongPressStats";
import DSCard from "views/system-design/DSCard";
import DSCardContent from "views/system-design/DSCardContent";
import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import DSSelect from "views/system-design/DSSelect";
import DSMenuItem from "views/system-design/DSMenuItem";
import DSCircularProgress from "views/system-design/DSCircularProgress";

const PRESET_DAYS = [7, 30, 90] as const;

function Stat({ label, value }: { label: string; value: number }) {
  return (
    <DSBox sx={{ flex: 1 }}>
      <DSTypography variant="h4">{value.toLocaleString()}</DSTypography>
      <DSTypography variant="body2" sx={{ color: "text.secondary" }}>
        {label}
      </DSTypography>
    </DSBox>
  );
}

function HeartLongPressWidget() {
  const theme = useTheme();
  const [days, setDays] = useState<number>(30);
  const { data, isLoading } = useHeartLongPressStats(days);

  return (
    <DSCard sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <DSBox
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          px: 2,
          pt: 2,
          gap: 1,
        }}
      >
        <DSTypography variant="h6">Heart Long Press — Chime</DSTypography>
        <DSSelect
          size="small"
          value={String(days)}
          onChange={(e) => setDays(Number(e.target.value))}
          sx={{ minWidth: 130 }}
        >
          {PRESET_DAYS.map((d) => (
            <DSMenuItem key={d} value={String(d)}>
              Last {d} days
            </DSMenuItem>
          ))}
        </DSSelect>
      </DSBox>
      <DSCardContent sx={{ flex: 1 }}>
        {isLoading ? (
          <DSBox sx={{ textAlign: "center", p: "20px" }}>
            <DSCircularProgress />
          </DSBox>
        ) : (
          <DSBox sx={{ display: "flex", gap: 2 }}>
            <Stat label="Clocks using it" value={data?.clocks ?? 0} />
            <Stat label="Long presses" value={data?.presses ?? 0} />
            <Stat label="Avg per clock" value={data?.avgPerClock ?? 0} />
          </DSBox>
        )}
      </DSCardContent>
      <DSBox
        sx={{ borderTop: `1px solid ${theme.palette.divider}`, px: 2, py: 1.5 }}
      >
        <DSTypography variant="caption" sx={{ color: "text.secondary" }}>
          Last {days} days · dev clocks excluded
        </DSTypography>
      </DSBox>
    </DSCard>
  );
}

export default HeartLongPressWidget;
